/**
 * Tracks usage of a tool by incrementing its counter in the database
 * Uses an API route to avoid client-side MongoDB issues
 */
export async function incrementToolUsage(toolName: string): Promise<void> {
  console.log(`Usage tracking: Tool '${toolName}' was used.`)
  // Simulate an API call delay
  await new Promise(resolve => setTimeout(resolve, 100)); 
  // In a real scenario, you might want to handle potential errors here.
  // For example, if the tracking API call fails, you might log it 
  // but not block the main application flow.
  return Promise.resolve()
}

/**
 * Tracks token usage for OpenAI API calls to monitor costs per tool
 * @param toolName The name of the tool making the API call
 * @param promptTokens Number of tokens in the prompt
 * @param completionTokens Number of tokens in the completion
 * @param model The model used (e.g., "gpt-4o-mini")
 */
export async function trackTokenUsage(
  toolName: string, 
  promptTokens: number, 
  completionTokens: number,
  model: string
): Promise<void> {
  try {
    await fetch('/api/track-token-usage', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        toolName,
        promptTokens,
        completionTokens,
        model
      }),
    })
  } catch (error) {
    console.error('Error tracking token usage:', error)
    // We don't want to break the main functionality if tracking fails
    // so we just log the error and continue
  }
} 